/**
 * The strategy-card marks an article can drop into its prose as `:mark{type=…}`.
 *
 * Named here rather than inline in the component so the build validator can
 * check an authored name without importing React — same split as the article
 * rules in validate.ts, and for the same reason: a mistyped mark renders
 * nothing, which is invisible in review and invisible in production.
 */
export const HELP_MARK_TYPES = [
  "long-only",
  "short-only",
  "long-and-short",
  "alt-symbols",
  "risk-1",
  "risk-2",
  "risk-3",
] as const;

export type HelpMarkType = (typeof HELP_MARK_TYPES)[number];

export function isHelpMarkType(value: string): value is HelpMarkType {
  return (HELP_MARK_TYPES as readonly string[]).includes(value);
}
